export const UPDATE_COLUMNS = 'UPDATE_COLUMNS'